const Locale = {
  ENGLISH: "en",
  CHINESE: "zh",
}

module.exports = {
  Locale,
  DEFAULT_LOCALE: Locale.ENGLISH,
}
